import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from '@mui/material';
import { showToast } from '@utils';
import { useCreateDbConfigMutation } from "../../../../../../store/feature/chat/knowledgeBase";

const AddDatabaseConfig = ({ onBack }) => {
    const [databaseConfig, setDatabaseConfig] = useState({
        host: '',
        port: '',
        username: '',
        password: '',
        database: '',
        database_type: ''
    });

    // Database type options
    const databaseTypes = [
        { value: 'postgres', label: 'PostgreSQL' },
        { value: 'mysql', label: 'MySQL' }
    ];

    // Handle form field changes
    const handleFormChange = (field, value) => {
        setDatabaseConfig((prev) => ({
            ...prev,
            [field]: value
        }));

        // Set default port when database type changes
        if (field === 'database_type') {
            const defaultPort = value === 'postgres' ? '5432' : value === 'mysql' ? '3306' : '';
            setDatabaseConfig((prev) => ({
                ...prev,
                port: defaultPort
            }));
        }
    };

    const [createDbConfig] = useCreateDbConfigMutation();

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        const configData = {
            host: databaseConfig.host,
            port: parseInt(databaseConfig.port),
            username: databaseConfig.username,
            password: databaseConfig.password,
            database: databaseConfig.database,
            database_type: databaseConfig.database_type
        };

        console.log('Submitting database config:', configData);

        // TODO: Send configData to API
        createDbConfig(configData)
            .then(() => {
                showToast('success','Database config added successfully');
                onBack();
            })
            .catch((error) => {
                console.error('Failed to create instance', error);
                // showToast(error?.data?.message, "error");
            });
        // Reset form
        setDatabaseConfig({
            host: '',
            port: '',
            username: '',
            password: '',
            database: '',
            database_type: ''
        });
    };

    // Check if form is valid
    const isFormValid = () => {
        return (
            databaseConfig.host &&
            databaseConfig.port &&
            databaseConfig.username &&
            databaseConfig.password &&
            databaseConfig.database &&
            databaseConfig.database_type
        );
    };

    return (
        <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
            {/* Header with Back Button */}
            {/* <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mb: 3,
                    gap: 2
                }}
            >
                <IconButton 
                    onClick={onBack}
                    sx={{ 
                        p: 1,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Add Database Configuration
                </Typography>
            </Box> */}

            {/* Database Configuration Form */}
            <Paper sx={{ p: 3, borderRadius: '8px' }}>
                <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Database Connection Details
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3
                    }}
                >
                    {/* Database Type Dropdown */}
                    <FormControl fullWidth>
                        <InputLabel>Database Type</InputLabel>
                        <Select
                            value={databaseConfig.database_type}
                            label="Database Type"
                            onChange={(e) =>
                                handleFormChange('database_type', e.target.value)
                            }
                        >
                            {databaseTypes.map((type) => (
                                <MenuItem key={type.value} value={type.value}>
                                    {type.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Host and Port */}
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="Host"
                            value={databaseConfig.host}
                            onChange={(e) =>
                                handleFormChange('host', e.target.value)
                            }
                            fullWidth
                            required
                        />
                        <TextField
                            label="Port"
                            value={databaseConfig.port}
                            onChange={(e) =>
                                handleFormChange('port', e.target.value)
                            }
                            sx={{ width: '120px' }}
                            required
                        />
                    </Box>

                    {/* Database Name */}
                    <TextField
                        label="Database Name"
                        value={databaseConfig.database}
                        onChange={(e) =>
                            handleFormChange('database', e.target.value)
                        }
                        fullWidth
                        required
                    />

                    {/* Username and Password */}
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="Username"
                            value={databaseConfig.username}
                            onChange={(e) =>
                                handleFormChange('username', e.target.value)
                            }
                            fullWidth
                            required
                        />
                        <TextField
                            label="Password"
                            type="password"
                            value={databaseConfig.password}
                            onChange={(e) =>
                                handleFormChange('password', e.target.value)
                            }
                            fullWidth
                            required
                        />
                    </Box>

                    {/* Action Buttons */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'flex-end',
                            mt: 2
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={onBack}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!isFormValid()}
                        >
                            Save Configuration
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default AddDatabaseConfig;
